module.exports = __webpack_public_path__ + "static/media/plan-hero-1-alt.42e8cf28.jpg";